<template><div><component-health-status-table :components-status="$page.componentsStatus" /></div></template>


<script setup>
    import ComponentHealthStatusTable from '@baseComponents/ComponentHealthStatusTable.vue';
</script>